export enum BannersKeysEnum {
  SEM_PARAR = "SEM_PARAR",
  BUDGET_WITH_SINGLE_COUNTERPROPOSAL = "BUDGET_WITH_SINGLE_COUNTERPROPOSAL"
}
